import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {FilterStorageService} from '../services/filter-storage.service';
import {Injectable} from '@angular/core';
import {ProductModel} from '../api/product-model';
import {ProductsService} from '../api/products.service';

@Injectable({
  providedIn: 'root'
})
export class ProductResolver implements Resolve<ProductModel> {
  constructor(private products: ProductsService,
              private  filtersService: FilterStorageService) {
  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ProductModel> | Promise<ProductModel> | ProductModel {
    const itemId = route.params.itemId;
    return this.products.getOne(this.filtersService.getSelectedOrganization().id, itemId);
  }
}
